import { FormGroup, ValidationErrors } from '@angular/forms';

export function getError(form: FormGroup, controlName: string, submitted: boolean = false): string | null {
  const control = form.get(controlName);
  if (!control) return null;

  const errors = control.errors;
  if (!errors) return null;
  const isArrayField = Array.isArray(control.value);

  if (isArrayField) {
    if ((control.touched || submitted) && control.invalid) {
      return mapError(errors);
    }
    return null;
  }

  if ((!control.touched && !submitted) || !control.invalid) return null;

  return mapError(errors);
}

function mapError(errors: ValidationErrors): string {
  if (errors['required']) return 'Este campo es obligatorio';
  if (errors['email']) return 'Formato de correo inválido';
  if (errors['groupAdministrationFormat']) {
    return 'Debe incluir al menos 1 letra y 1 número, sin espacios';
  }
  if (errors['pattern']) return 'No se permiten los caracteres # o :';
  if (errors['integerOnly']) return 'Solo se permiten números enteros';
  if (errors['min']) {
    const minError = errors['min'] as { min?: number };
    return `El valor debe ser mayor o igual a ${minError.min}`;
  }
  if (errors['dateInFuture']) return 'La fecha no puede ser futura';
  if (errors['maxlength']) {
    const maxLengthError = errors['maxlength'] as { requiredLength?: number };
    return `Máximo ${maxLengthError.requiredLength} caracteres`;
  }
  if (errors['minlength']) {
    const minLengthError = errors['minlength'] as { requiredLength?: number };
    return `Mínimo ${minLengthError.requiredLength} caracteres`;
  }

  return 'Campo inválido';
}
